// src/components/layout/PageLayout.jsx
import React from 'react';
import useScrollPosition from '../../../hooks/useScrollPosition';
import Navbar from './Navbar';
import Footer from './Footer';
import QuoteForm from '../forms/QuoteForm';

const PageLayout = ({ children }) => {
  const scrollPosition = useScrollPosition();

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {/* Scroll progress bar */}
      <div className="h-1 bg-blue-100 fixed top-0 left-0 right-0 z-50">
        <div 
          className="h-full bg-blue-600 transition-all duration-300" 
          style={{ 
            width: `${Math.min(
              (scrollPosition / (document.body.scrollHeight - window.innerHeight)) * 100, 
              100
            )}%`
          }}
        />
      </div>

      <Navbar />
      
      <div className="flex-grow flex flex-col md:flex-row gap-6 md:gap-8 lg:gap-10 px-4 sm:px-6 lg:px-8 mt-20 md:mt-24">
        {/* Mobile View - QuoteForm First */}
        <div className="md:hidden w-full mb-6">
          <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-5">
            <QuoteForm />
          </div>
        </div>
        
        {/* Main content area */}
        <main className="flex-grow md:w-2/3 overflow-y-auto order-2 md:order-1">
          <div className="max-w-4xl mx-auto">
            {children}
          </div>
        </main>
        
        {/* Right sidebar - Desktop Only */}
        <aside className="hidden md:block md:w-1/3 md:sticky md:top-24 md:h-[calc(100vh-7rem)] md:overflow-y-auto order-1 md:order-2">
          <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-6 lg:p-8">
            <QuoteForm />
          </div>
        </aside>
      </div>

      <Footer />
    </div>
  );
};

export default PageLayout;
